// extracted by mini-css-extract-plugin
export var buttonFadeInAnimation = "FullScreenPlayerCard-module--buttonFadeInAnimation--f0fc8";
export var card = "FullScreenPlayerCard-module--card--e08ff";
export var content = "FullScreenPlayerCard-module--content--6f836";
export var fadeInAnimation = "FullScreenPlayerCard-module--fadeInAnimation--cf2bc";
export var fullScreenButton = "FullScreenPlayerCard-module--fullScreenButton--a6182";
export var fullScreenIcon = "FullScreenPlayerCard-module--fullScreenIcon--1b10a";
export var hideWhilePlaying = "FullScreenPlayerCard-module--hideWhilePlaying--eb757";
export var leftSide = "FullScreenPlayerCard-module--leftSide--8ecaf";
export var name = "FullScreenPlayerCard-module--name--ebf02";
export var playIcon = "FullScreenPlayerCard-module--playIcon--afd0a";
export var playerButton = "FullScreenPlayerCard-module--playerButton--e55a3";
export var playerButtonIcon = "FullScreenPlayerCard-module--playerButtonIcon--d05d6";
export var playerFloatingButton = "FullScreenPlayerCard-module--playerFloatingButton--7ce87";
export var playerHead = "FullScreenPlayerCard-module--playerHead--c0941";
export var position = "FullScreenPlayerCard-module--position--e3dc7";
export var progressBar = "FullScreenPlayerCard-module--progressBar--d27c2";
export var progressBarBackground = "FullScreenPlayerCard-module--progressBarBackground--6f91d";
export var progressBarContainer = "FullScreenPlayerCard-module--progressBarContainer--efd0a";
export var showControls = "FullScreenPlayerCard-module--showControls--49bb8";
export var showOnDesktop = "FullScreenPlayerCard-module--showOnDesktop--8d299";
export var text = "FullScreenPlayerCard-module--text--564e2";
export var time = "FullScreenPlayerCard-module--time--f7d79";
export var title = "FullScreenPlayerCard-module--title--5a239";
export var video = "FullScreenPlayerCard-module--video--b790e";
export var videoControls = "FullScreenPlayerCard-module--videoControls--09379";
export var videoWrapper = "FullScreenPlayerCard-module--videoWrapper--4215e";
export var volume = "FullScreenPlayerCard-module--volume--252ae";
export var volumeIcon = "FullScreenPlayerCard-module--volumeIcon--098cd";
export var volumeInput = "FullScreenPlayerCard-module--volumeInput--78f37";
export var volumeInputContainer = "FullScreenPlayerCard-module--volumeInputContainer--f980b";